import AnalyzesPage from "./AnalyzesPage";

export default AnalyzesPage;
